import styled from "styled-components";

export const MenuHead = styled.h6`
  font-size: 16px;
  font-weight: 500;
`;
